import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logOut } from "../../redux/actions/authActions/authAction";
import { viewMeetingActionDetails } from "../../redux/actions/meetingActions/MeetingAction";
import { useNavigate } from "react-router-dom";
import { convertFirstLetterToCapital } from "../../helpers/commonHelpers";
import { Accordion, OverlayTrigger, Popover } from "react-bootstrap";
import Loader from "../Common/Loader";
import NoDataFound from "../Common/NoDataFound";
import Alert from "../Common/Alert";
const Statistics = React.memo((props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const authData = useSelector((state) => state.auth);
  const [singleMeetingAllActionDetails, setSingleMeetingAllActionDetails] =
    useState(null);
  const [
    singleMeetingUserWiseActionDetails,
    setSingleMeetingUserWiseActionDetails,
  ] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }

  useEffect(() => {
    const callAPI = async () => {
      if (props?.meetingId) {
        setIsLoading(true);
        const result = await dispatch(
          viewMeetingActionDetails(props?.meetingId, accessToken)
        );

        setIsLoading(false);
        if (result?.status) {
          setSingleMeetingAllActionDetails(result?.data?.all);
          setSingleMeetingUserWiseActionDetails(result?.data?.users);
        }
      }
    };
    callAPI();
  }, [props?.meetingId]);

  const popoverHoverFocus = (title, email) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">
          {title} ({email})
        </Popover.Body>
      </Popover>
    );
  };
  return (
    <>
      <label className="mt-2 mb-3 add-agenda">
        <h4>Action Summary</h4>
      </label>

      {singleMeetingAllActionDetails &&
      singleMeetingAllActionDetails?.length !== 0 ? (
        <>
          <div className="table-responsive">
            <table
              className="mt-2 table table-bordered table-striped"
              border="1"
              cellPadding="8"
              cellSpacing="0"
            >
              <thead >
                <tr >
                  <th >Status</th>
                  <th className="text-align-center">Total</th>
                  <th className="text-align-center">Delay</th>
                  <th className="text-align-center">Not Delay</th>
                </tr>
              </thead>
              <tbody>
                {singleMeetingAllActionDetails &&
                  singleMeetingAllActionDetails?.length !== 0 &&
                  singleMeetingAllActionDetails?.map((action) => {
                    return (
                      <tr >
                        <td>
                          {action?.category === "COMPLETED" ? (
                            <span className="badge completed-color bg-opacity-10 ">
                              {convertFirstLetterToCapital(action?.category)}
                            </span>
                          ) : action?.category === "PENDING" ? (
                            <span className="badge pending-color bg-opacity-10">
                              {convertFirstLetterToCapital(action?.category)}
                            </span>
                          ) : action?.category === "CANCELLED" ? (
                            <span className="badge canceled-color bg-opacity-10 ">
                              {convertFirstLetterToCapital(action?.category)}
                            </span>
                          ) : (
                            <span className="badge  bg-opacity-10 draft-color">
                              {convertFirstLetterToCapital(action?.category)}
                            </span>
                          )}
                        </td>
                        <td className="text-align-center">
                          {action?.total} ({Math.floor(action?.percentage)}%)
                        </td>
                        <td
                          style={{ color: "red" }}
                          className="text-align-center"
                        >
                          {action?.delay}
                        </td>
                        <td
                          style={{ color: "green" }}
                          className="text-align-center"
                        >
                          {action?.notDelay}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="minutes-border"></div>
          <div className="table-responsive">
            {singleMeetingUserWiseActionDetails &&
              singleMeetingUserWiseActionDetails.length !== 0 && (
                <>
                  <label className="">
                    <h4 className="mt-2">Attendee(s) Action Summary</h4>
                  </label>
                  {singleMeetingUserWiseActionDetails.map(
                    (userActionDetails, index) => (
                      <>
                        <div className="agenda-box-border">
                          <Accordion defaultActiveKey="0">
                            <Accordion.Item
                              eventKey={index.toString()}
                              key={index}
                              className="agenda-accordion"
                            >
                              <Accordion.Header>
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  placement="bottom"
                                  overlay={popoverHoverFocus(
                                    userActionDetails?.userInfo?.name,
                                    userActionDetails?.userInfo?.email
                                  )}
                                >
                                  <div className="d-flex justify-content-between w-100">
                                    <div className="d-flex justify-content-between">
                                      <span className="meeting-title action-summary-title">
                                        <span className="fs-15">
                                          {userActionDetails?.userInfo?.name}
                                        </span>
                                        <span className="pre-wrap-text fs-15">
                                          {" "}
                                          ({userActionDetails?.userInfo?.email})
                                        </span>
                                      </span>
                                    </div>
                                    <div>
                                      <span className="agenda-span badge">
                                        {
                                          userActionDetails?.data?.find(
                                            (item) => item.category === "All"
                                          )?.total
                                        }
                                      </span>
                                    </div>
                                  </div>
                                </OverlayTrigger>
                              </Accordion.Header>
                              <Accordion.Body className="attendees-action-summary-table p-0">
                                <div className="table-responsive">
                                  <table
                                    className="table table-striped"
                                    key={index}
                                    cellPadding="8"
                                    cellSpacing="0"
                                  >
                                    <tr >
                                      <th>Status</th>
                                      <th className="text-align-center">
                                        Total
                                      </th>
                                      <th className="text-align-center">
                                        Delay
                                      </th>
                                      <th className="text-align-center">
                                        Not Delay
                                      </th>
                                    </tr>
                                    

                                    {userActionDetails?.data?.map(
                                      (action, idx) => {
                                        const total = action?.total ?? 0;
                                        const delay = action?.delay ?? 0;
                                        const notDelay = action?.notDelay ?? 0;
                                        const percentage =
                                          action?.percentage != null
                                            ? action.percentage
                                            : 0;

                                        return (
                                          <tr key={idx} >
                                            <td>
                                              {action?.category ===
                                              "COMPLETED" ? (
                                                <span className="badge completed-color bg-opacity-10 statstics">
                                                  {convertFirstLetterToCapital(
                                                    action?.category
                                                  )}
                                                </span>
                                              ) : action?.category ===
                                                "PENDING" ? (
                                                <span className="badge pending-color bg-opacity-10 statstics">
                                                  {convertFirstLetterToCapital(
                                                    action?.category
                                                  )}
                                                </span>
                                              ) : action?.category ===
                                                "CANCELLED" ? (
                                                <span className="badge canceled-color bg-opacity-10 statstics">
                                                  {convertFirstLetterToCapital(
                                                    action?.category
                                                  )}
                                                </span>
                                              ) : (
                                                <span className="badge draft-color bg-opacity-10 statstics">
                                                  {convertFirstLetterToCapital(
                                                    action?.category
                                                  )}
                                                </span>
                                              )}
                                            </td>
                                            <td className="text-align-center">
                                              {total} ({Math.floor(percentage)}
                                              %)
                                            </td>
                                            <td
                                              style={{ color: "red" }}
                                              className="text-align-center"
                                            >
                                              {delay}
                                            </td>
                                            <td
                                              style={{ color: "green" }}
                                              className="text-align-center"
                                            >
                                              {notDelay}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                   
                                  </table>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      </>
                    )
                  )}
                </>
              )}
          </div>
        </>
      ) : !isLoading &&
        singleMeetingAllActionDetails &&
        singleMeetingAllActionDetails?.length === 0 ? (
        <div className="no-data-img mt-3">
          <Alert
            status={"info"}
            message={"No actions available."}
            timeoutSeconds={0}
          />
          <NoDataFound dataType={"meeting"} />
        </div>
      ) : (
        <div className="loader-center">
          <Loader />
        </div>
      )}
    </>
  );
});

export default Statistics;
